import { authFetchJson } from '../api';
import type {
  SeasonLeaderboardResponse,
  SeasonMeResponse,
  SeasonScope,
} from '@shared/seasons';
import { SEASON_LEADERBOARD_LIMIT } from '@shared/seasons';

/**
 * The signed-in player's standing in every scope (overall + each mode):
 * rank, participant count, and the three currency totals. Backs both the
 * TopNav crown chip and the Seasons page status cards.
 */
export async function fetchSeasonStandings(): Promise<SeasonMeResponse> {
  return authFetchJson<SeasonMeResponse>('/api/seasons/me');
}

/** One scope's season leaderboard (top {@link SEASON_LEADERBOARD_LIMIT}) plus the caller's own row. */
export async function fetchSeasonLeaderboard(
  scope: SeasonScope,
  limit: number = SEASON_LEADERBOARD_LIMIT,
): Promise<SeasonLeaderboardResponse> {
  const params = new URLSearchParams({ scope, limit: String(limit) });
  return authFetchJson<SeasonLeaderboardResponse>(`/api/seasons/leaderboard?${params.toString()}`);
}
